export const apiUrl = {
    // 用户
    userLogin: '/service/XusUser/Controller/XusUserController/userLogin',
    // 查询联系我们
    getContact: '/service/XusContact/Controller/XusContactController/getContact',
    // 查询演示站地址
    getXusDemoInfo: '/service/XusDemoInfo/Controller/XusDemoInfoController/getXusDemoInfo',
    // 用户邮箱地址
    addEmailUser: '/service/XusUser/Controller/XusUserController/addEmailUser',
    // 发送邮箱验证码
    emailCode: '/com/examilp/service/emial/mailController/emailCode',
    // 验证邮箱验证码
    emailCodeYN: '/com/examilp/service/emial/mailController/emailCodeYN',
    // 查看用户账单
    getUserOrders: '/service/UserOrders/Controller/UserOrdersController/getUserOrders',
    // 安装包下载
    download: '/service/UserOrders/Controller/UserOrdersController/download',
    // 发送邮箱验证码
    send: '/api/aliyun/send',
    // 验证邮箱验证码
    sendCodeYN: '/api/aliyun/sendCodeYN'
}